import React from 'react';

import MapLayersOptionsView from './MapLayersOptions.view';
import { IPickedLayer, LayersTypes } from '../MapLayers.model';
import { useLayersItems } from './MapLayersOptions.utils';

type Props = {
  onEnterMapLayer: () => void;
  onLeaveMapLayer: () => void;
  onClickLayer: (layer: LayersTypes | null) => void;
  pickedLayer: IPickedLayer | null;
  layerTypeOptions?: LayersTypes[];
};

const MapLayersOptions: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const layersItems = useLayersItems(props.layerTypeOptions);

  return (
    <MapLayersOptionsView
      onEnterMapLayer={props.onEnterMapLayer}
      onLeaveMapLayer={props.onLeaveMapLayer}
      layersItems={layersItems}
      onClickLayer={props.onClickLayer}
      pickedLayer={props.pickedLayer}
    >
      {props.children}
    </MapLayersOptionsView>
  );
};

MapLayersOptions.displayName = 'MapLayersOptions';
MapLayersOptions.defaultProps = {};

export default MapLayersOptions;
